import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const FormError = (props) => {
    const { error } = props;

    return (
        <Fragment>
            <div
                style={{ display: 'block' }}
                className={props.class ? props.class + ' invalid-feedback' : 'invalid-feedback'}
            >
                {error}
            </div>
        </Fragment>
    );
};

export default FormError;
